<template>
  <div v-if="courier">
    <HContainer>
      <template #content>
        <HBorderPanel :spec-list-item="courierDetail">
          <template #heading>配送情報</template>
          <template #footer>
            <div class="p-h-border-panel__note">
              <p>
                以下のURLからお客様のお荷物の配送状況がご確認いただけます。
                <br />
                <TextLink
                  :href="courier.tracking_url"
                  :has-underline="true"
                  :blank="true"
                  >{{ courier.tracking_url }}</TextLink
                >
              </p>
            </div>
          </template>
        </HBorderPanel>
      </template>
    </HContainer>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TextLink from "@/common/components/atoms/TextLink.vue";
import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HBorderPanel from "@/general/components/pages/parts/PointHistoryList/HBorderPanel.vue";

@Options({
  props: {
    courier: { type: [Object, Boolean], default: false }
  },
  components: {
    TextLink,
    HContainer,
    HBorderPanel
  }
})
export default class HDeliveryDetails extends Vue {
  courier!: any | undefined | boolean;

  get courierDetail(): any {
    return this.courier
      ? [
          {
            label: "配送日",
            detail: [this.courier.date]
          },
          {
            label: "配送業者名",
            detail: [this.courier.company_name]
          },
          {
            label: "問い合わせ荷物番号",
            detail: [this.courier.reference_package_number]
          }
        ]
      : false;
  }
}
</script>
